const Loading = () => (
    <div className="loading">
      <p>Loading...</p>
    </div>
  );
  
export default Loading;